import { COMMENT_ADD,
  COMMENT_REQUEST,
  COMMENT_SUCCESS,
  COMMENT_EMPTY,
  COMMENT_ERROR } from '@/store/actions/comments'
import Api from '@/services/Api'

const state = {
  status: '',
};

const getters = {
};

const actions = {
  [COMMENT_ADD]: ({commit, dispatch}, comment) => {
    return new Promise((resolve, reject) => {
      commit(COMMENT_REQUEST)
      Api().post('/comments/'+ comment.gid, comment)
      .then(function (response) {
        commit(COMMENT_SUCCESS, response);
        resolve(response);
      })
      .catch(function (error) {
        commit(COMMENT_ERROR);
        reject(error);
      });
    });
  },

  [COMMENT_REQUEST]: ({commit, dispatch}, gid) => {
    return new Promise((resolve, reject) => {
      commit(COMMENT_REQUEST)
      Api().get('/comments/'+ gid)
      .then(function (response) {
        commit(COMMENT_SUCCESS, response);
        resolve(response);
      })
      .catch(function (error) {
        commit(COMMENT_ERROR);
        reject(error);
      });
    });
  }
};

const mutations = {
  [COMMENT_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [COMMENT_SUCCESS]: (state) => {
    state.status = 'success';
  },
  [COMMENT_EMPTY]: (state) => {
    state.status = 'empty';
  },
  [COMMENT_ERROR]: (state) => {
    state.status = 'error';
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
}
